/*eslint-disable array-callback-return */
/*eslint-disable linebreak-style */
/*eslint-disable eqeqeq */
/*eslint-disable no-redeclare */
/*eslint-disable no-unused-vars */
import React from 'react';
import ShowMore from './showmore';
import MemberCoverageSummary from '../../../api/MemberCoverageSummary';

const item2 = ['Medical', 'Dental', 'Vision', 'i2d4'];

class ShowMoreView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      item2: [],
    };
    MemberCoverageSummary.coverageList = [];
    MemberCoverageSummary.coverageType = [];
    MemberCoverageSummary.listShow = 0;
    MemberCoverageSummary.listLen = 0;
    MemberCoverageSummary.dispList = 'Show More';
    MemberCoverageSummary.prevName = '';
  }

  render() {
    console.log('Showmore');
    const { item2 } = this.state;
    return (
      <div className="d-md-none d-xs-block d-sm-block">
        {/*<ShowMore index="2" item="item2" itemData={item2} />*/}
        <ShowMore />
      </div>
    );
  }
}
export default ShowMoreView;
